import {TMaxDiffRow} from "../MaxDiffState";
import m, {Vnode} from "mithril";
import MaxDiffDragdrop from "./MaxDiffDragdrop";

export default class MaxDiffCard {

    private isDragging = false;

    constructor(
        private readonly container: MaxDiffDragdrop,
        private readonly row: TMaxDiffRow
    ) { }


    public view(): Vnode {
        const questionary = this.row.label.questionary;
        const value = <string>this.row.ratings[this.container.state.round].getVariable();

        return m('.MaxDiffCard.value-'+value+(this.isDragging?'.dragging':''), {
            'data-row': this.row.label.cell.row,
        }, [
            this.row.image ? m(this.row.image) : null,
            m('label', {}, questionary.renderText(this.row.label.label ?? '')),
            m('.handle', {}, [
                m('i.icon.icon-drag-handle.accent', {}, ''),
            ]),
        ]);
    }


}